import { RiArrowRightUpLine } from "@remixicon/react"
import { FadeContainer, FadeDiv, FadeSpan } from "../Fade"
import GameOfLife from "./HeroBackground"

export function CharlestonHero() {
  return (
    <section aria-label="hero">
      <FadeContainer className="relative flex flex-col items-center justify-center">
        <FadeDiv className="mx-auto">
          <a
            aria-label="Charleston's premier marketing agency"
            href="#services"
            className="mx-auto w-full"
          >
            <div className="inline-flex max-w-full items-center gap-3 rounded-full bg-white/5 px-2.5 py-0.5 pr-3 pl-0.5 font-medium text-gray-900 ring-1 shadow-lg shadow-[#003566]/20 ring-black/10 filter backdrop-blur-[1px] transition-colors hover:bg-[#003566]/[2.5%] focus:outline-hidden sm:text-sm">
              <span className="shrink-0 truncate rounded-full border bg-gray-50 px-2.5 py-1 text-sm text-gray-600 sm:text-xs">
                Charleston, SC
              </span>
              <span className="flex items-center gap-1 truncate">
                <span className="w-full truncate">
                  Trusted by 100+ local businesses
                </span>
                <RiArrowRightUpLine className="size-4 shrink-0 text-gray-700" />
              </span>
            </div>
          </a>
        </FadeDiv>
        <div className="mt-8 flex flex-col items-center">
          <img
            src="/logo.png"
            alt="Marketier Agency Logo"
            className="h-24 w-auto mb-4"
            onError={(e) => {
              // Fallback if image doesn't load
              e.currentTarget.style.display = 'none';
              const fallback = document.createElement('h1');
              fallback.className = "text-center text-5xl font-semibold tracking-tighter text-gray-900 sm:text-8xl sm:leading-[5.5rem]";
              fallback.textContent = "Marketier Agency";
              e.currentTarget.parentElement?.appendChild(fallback);
            }}
          />
          <h1 className="text-center text-5xl font-semibold tracking-tighter text-gray-900 sm:text-8xl sm:leading-[5.5rem]">
            <FadeSpan>Your Growth</FadeSpan> <FadeSpan>Partner</FadeSpan>
          </h1>
        </div>
        <p className="mt-5 max-w-2xl text-center text-base text-balance text-gray-700 sm:mt-8 sm:text-xl">
          <FadeSpan>We help small businesses dominate their market</FadeSpan>{" "}
          <FadeSpan>with expert branding, web development, SEO,</FadeSpan>{" "}
          <FadeSpan>social media management, and targeted advertising.</FadeSpan>
        </p>
        <FadeDiv className="mt-6 flex flex-col sm:flex-row gap-4">
          <a
            className="inline-flex cursor-pointer flex-row items-center justify-center gap-1 rounded-md border-b-[1.5px] border-[#0ea5e9] bg-gradient-to-b from-[#06b6d4] to-[#0ea5e9] px-6 py-3 leading-4 font-medium tracking-wide whitespace-nowrap text-white shadow-[0_0_0_2px_rgba(14,165,233,0.1),0_0_20px_0_rgba(14,165,233,0.4)] transition-all duration-200 ease-in-out hover:shadow-[0_0_0_2px_rgba(14,165,233,0.15),0_0_28px_0_rgba(14,165,233,0.6)] hover:scale-105"
            href="https://airtable.com/appR9wgPnwfYKJA5f/pagEhOnZkUUuOZskP/form"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Free Consultation
          </a>
          <a
            className="inline-flex cursor-pointer flex-row items-center justify-center gap-1 rounded-md border border-gray-300 bg-white px-6 py-3 leading-4 font-medium tracking-wide whitespace-nowrap text-gray-900 shadow-xs transition-all duration-200 ease-in-out hover:bg-gray-50"
            href="#services"
          >
            View Our Services
          </a>
        </FadeDiv>
        <FadeDiv className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            Serving the Lowcountry: Charleston, Mount Pleasant, Summerville, North Charleston & Beyond
          </p>
        </FadeDiv>
        <div className="absolute inset-0 -z-10 flex items-center justify-center">
          <GameOfLife />
        </div>
      </FadeContainer>
    </section>
  )
}
